import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PainSection } from './components/PainSection';
import { SystemRevealSection } from './components/SystemRevealSection';
import { VolumesSection } from './components/VolumesSection';
import { ProductCarouselSection } from './components/ProductCarouselSection';
import { TransitionImage } from './components/TransitionImage';
import { EbookCarouselSection } from './components/EbookCarouselSection';
import { MidPageCta } from './components/MidPageCta';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { ComparisonSection } from './components/ComparisonSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { ClosingCtaSection } from './components/ClosingCtaSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { PurchaseToast } from './components/PurchaseToast';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full max-w-full overflow-x-clip bg-charcoal-950 pb-20 font-sans text-body lg:pb-0" data-id="element-0" data-mp="682dxcgkib2">
      <Hero data-id="element-1" data-mp="2zm4xcjfp5b1a" />

      <main data-id="element-2" data-mp="2zmo3z3zwcd00">
        <TestimonialsSection data-id="element-3" data-mp="2zmwh8wzxlkbq" />
        <PainSection data-id="element-4" data-mp="33moqzd129wio" />
        <SystemRevealSection data-id="element-5" data-mp="33lwywc6oagx5" />
        <VolumesSection data-id="element-6" data-mp="33n6xr3lcnt4u" />
        <ProductCarouselSection data-id="element-7" data-mp="33oi2b5mmd4x0" />
        <TransitionImage data-id="element-8" data-mp="38l8hlqqlnwhd" />
        <EbookCarouselSection data-id="element-9" data-mp="38l05i12awv78" />
        <MidPageCta data-id="element-10" data-mp="38nulngea7tuu" />
        <BonusesSection data-id="element-11" data-mp="3dkl42adk71jf" />
        <OfferSection data-id="element-12" data-mp="3dl4jnkfqldua" />
        <TestimonialsSection variant="compact" id="proof-2" data-id="element-13" data-mp="3dmfqjt4hb1pm" />
        <ComparisonSection data-id="element-14" data-mp="nw2bq4xkjoqk" />
        <GuaranteeSection data-id="element-15" data-mp="nur8c681cizz" />
        <FaqSection data-id="element-16" data-mp="nxn4pq48izmb" />
        <ClosingCtaSection data-id="element-17" data-mp="sunfgec14qjr" />
        <FinalOfferSection data-id="element-18" data-mp="stub1k0jmd4s" />
      </main>

      <Footer data-id="element-19" data-mp="swqc3h7othxg" />
      <StickyCta data-id="element-20" data-mp="swghthfm0oly" />
      <PurchaseToast data-id="element-21" data-mp="3688dot76uy6" />
    </div>;
}